module.exports = "img/room_replaced.4ac105f.svg";